/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { FC, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { getRouteConfig } from "../../../../config/route.config";
import FixedHeader from "~/features/header/components/FixedHeader";
import PageHeader from "~/features/header/components/PageHeader";

const Header: FC = () => {
  const location = useLocation();
  const { t } = useTranslation("common");

  const { header, pageHeader } = getRouteConfig(location.pathname);

  if (!header) {
    return null;
  }

  const pageTitle = pageHeader.title ? t(pageHeader.title) : "";

  return (
    <Fragment>
      <FixedHeader />
      {pageHeader.enabled && <PageHeader title={pageTitle} />}
    </Fragment>
  );
};

export default Header;
